import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { business } from '../data/business';
import { useLanguage } from '../contexts/LanguageContext';
export function FinalCTA() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-gold py-16 lg:py-20" data-id="element-121" data-mp="c7tuvjfx6qti">
      <div className="mx-auto max-w-content px-5 text-center lg:px-8" data-id="element-122" data-mp="856zx9nycps3">
        <h2 className="mx-auto max-w-3xl font-display text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl lg:text-5xl" data-id="element-123" data-mp="83vxpea5nq33">
          {t.finalCta.title}
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-ink/80 lg:text-lg" data-id="element-124" data-mp="h52gju0a1czi">
          {t.finalCta.body}
        </p>
        <a href={business.phoneHref} className="mt-9 inline-flex w-full items-center justify-center gap-3 rounded-sm bg-ink px-8 py-5 font-display text-lg font-bold uppercase tracking-wider text-gold transition-colors duration-150 ease-out hover:bg-panel sm:w-auto sm:text-xl" data-id="element-125" data-mp="vwuhv238kqi8">
          <PhoneIcon className="h-6 w-6" aria-hidden="true" data-id="element-126" data-mp="zuijenzfphj3" />
          {t.finalCta.callPrefix} {business.phoneDisplay}
        </a>
        <p className="mt-5 text-sm font-medium uppercase tracking-widest text-ink/70" data-id="element-127" data-mp="2h37zx4tb4x29">
          {t.finalCta.note}
        </p>
      </div>
    </section>;
}